import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fonts } from '../../Styles';
import { FeedCurve } from '../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall';
import { FeedCurveMiniature, NewButton } from '..';
import { GlobalMenu_Pages } from '../../Navigation/pages';
import { useNavigate } from "react-router";
import { NavigationFunction as RootNavigation, } from "../../Navigation/root";


interface FeedCurveCard_Props {
  feedCurve: FeedCurve;
  onFeedCurveSelect?: (id: number) => void;
  farm?: string
}

export default function FeedCurveCard({ feedCurve, onFeedCurveSelect, farm }: FeedCurveCard_Props) {  
  const { t } = useTranslation();
  const navigator = useNavigate();
  const [isSectionHovered, setIsSectionHovered] = useState(false);
  const [cardHeight, setCardHeight] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);
  const cardRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && cardRef.current) {
      const timeout = setTimeout(() => {
        if (cardRef.current) {
          setCardHeight(cardRef.current.scrollHeight);
          setContainerHeight(cardRef.current.scrollHeight + 60);
        }
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [feedCurve]);  

  if (!feedCurve || !feedCurve.components || !feedCurve.milestones) return <div>{t("noData", {defaultValue: "No Data"})}</div>;

  const isDefault = feedCurve.info?.default
  const isActive = feedCurve.info?.active
  
  return (
    <>
      <div
        ref={containerRef}
        onMouseEnter={() => setIsSectionHovered(true)}
        onMouseLeave={() => setIsSectionHovered(false)} 
        style={{
          // marginBottom: "20px",
          maxHeight: isSectionHovered ? containerHeight : 250,
          overflow: "hidden",
          transition: "0.5s ease",
        }}
      >
        <div
          ref={cardRef}
          onClick={onFeedCurveSelect ? () => onFeedCurveSelect(feedCurve.feedCurveId) : undefined } 
          style={{
          maxHeight: isSectionHovered ? cardHeight : 250,
          breakInside: "avoid",
          border: "5px solid " + colors.greyPrimary, 
          backgroundColor: colors.greyLightTertiary,
          minWidth: "320px",
          width: "100%",
          boxSizing: "border-box",
          transition: "0.3s ease",
          overflow: "hidden",
          cursor: "pointer",
          borderRadius: "10px",
        }}>
          <div style={{backgroundColor: colors.greyPrimary, height: "50px", display: "flex", flexDirection: "column", pointerEvents: 'none', alignItems: "center", justifyContent: "center", position: "relative" }}>
            <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary }}>{feedCurve.name}</p>
            <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary }}>{t("feed.feedCurve.feedCurve", {defaultValue: "Feed Curve"})} {feedCurve.feedCurveId}</p>
            <div style={{position: "absolute", top: "2px", right: "4px"}}>
              <p style={{...fonts.header, ...fonts.fontSize5, color: colors.blueLightPrimary, textAlign: "right" }}>{ isActive? "• " + t("feed.feedCurve.active", {defaultValue: "Active"}) : ""}</p>
              <p style={{...fonts.header, ...fonts.fontSize5, color: colors.greyLightTertiary, textAlign: "right" }}>{ isDefault? t("default", {defaultValue: "Default"}) : ""}</p>
            </div>
          </div>
          <div style={{padding: "20px", pointerEvents: 'none'}}><FeedCurveMiniature data={feedCurve} showLabels/></div>
        
        </div>
        <div style={{opacity: isSectionHovered ? "1" : "0", transition: "0.5s", marginTop: "10px", display: "flex", justifyContent: "center", width: "100%"}}>
          <NewButton
            content={t("feedCurvePages.feedCurves.goToFeedCurvePage", {defaultValue: "go to feedcurve page"})}
            onClick={() => {RootNavigation({ Navigator: navigator, navigation_page: GlobalMenu_Pages.feedCurves, navigation_tab: GlobalMenu_Pages.feedCurve, replace: true, navArgs: { selected: feedCurve?.feedCurveId }, currentDomain: farm })}}
            overrides={{
              baseStyles: { backgroundColor: colors.greyPrimary },
              hoverStyles: { backgroundColor: colors.greySecondary }
            }}
          />
        </div>
      </div>
    </>
  );
}